module.exports = __webpack_public_path__ + "static/assets/b6162ffbfe48d4b6c67f0b469f1615ae.png";